import { QuestionCard } from './types'

// Sample data structure - replace with actual parsed data
export const questionCards: QuestionCard[] = [
  {
   name: 'Question 1',
   subject: 'Mindset & Purpose',
   question: 'Your sense of purpose is at an Inflection Point. How do you intend to redirect your drive for accomplishment into new activities or passions?',
   videoUrl: 'http://www.youtube.com/watch?v=BQ2_BwqcFsc',
  }, 
  {
    name: 'Question 2',
    subject: 'Health & Well-being',
    question: 'Your access to workplace wellness programs is at an Inflection Point. What new personal health resources are you actively seeking out and utilizing?',
    videoUrl: 'http://www.youtube.com/watch?v=rkZl2gsLUp4',
  },
  {
          name: 'Question 3',
          subject: 'Finances & Future',
    question: 'Your role as a primary earner may be at an Inflection Point. How are you navigating this shift within your household and personal identity?',
          videoUrl:	'http://www.youtube.com/watch?v=vlpKyLklDDY',
  },
  {
    name: 'Question 4',
    subject: 'Connection & Legacy',
    question: 'Your sense of collective purpose with colleagues is at an Inflection Point. Where are you now finding a sense of belonging and shared mission?',
    videoUrl: 'http://www.youtube.com/watch?v=Nu16QnpHUAE',
  },
  {
    name: 'Question 5',
    subject: 'Housing & Community',
    question: 'Your shared living space and relationship with your spouse is at an Inflection Point. How are you proactively addressing new dynamics and negotiating shared time/hobbies?',
    videoUrl: 'http://www.youtube.com/watch?v=kzfAOc4L6vQ',
  },
]
